
const newModel = () => {
    return {
        nhaXeId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        gioiThieu: null,
        tuyenDuong: null,
        giaTien: null,
        soChuyen: null,
        web: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null
    }
}

const newFEModel = () => {
    return {
        nhaXeId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        gioiThieu: null,
        tuyenDuong: null,
        giaTien: null,
        soChuyen: null,
        web: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        nhaXeId: item.nhaXeId,
        ten: item.ten,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        diaChi: item.diaChi,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        sdt: item.sdt,
        gioiThieu: item.gioiThieu,
        tuyenDuong: item.tuyenDuong,
        giaTien: item.giaTien,
        soChuyen: item.soChuyen,
        web: item.web,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
        iocId: item.iocId,
        iocEnabled: item.iocEnabled,
        iocDateUpdated: item.iocDateUpdated,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const parseModeltoFEModel = (item) => {
    return {
        nhaXeId: item.nhaXeId,
        ten: item.ten,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        diaChi: item.diaChi,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        sdt: item.sdt,
        gioiThieu: item.gioiThieu,
        tuyenDuong: item.tuyenDuong,
        giaTien: item.giaTien,
        soChuyen: item.soChuyen,
        web: item.web,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        ten: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        ten: item.ten,
        enabled: item.enabled,
    }
}


const errors = () => {
    return {
        nhaXeId: null,
        ten: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        gioiThieu: null,
        tuyenDuong: null,
        giaTien: null,
        soChuyen: null,
        web: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

export const nhaXeModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    newSearchModel,
    fromJson,
    errors,
}


